/* globals sf_sdk */
;(function serviceformFix() {
  function clickElementOnEnter(arg1, arg2) {
    var callback,
      event = arg1
    // binding a callback puts the event as last argument
    if (typeof arg2 !== 'undefined') {
      callback = arg1
      event = arg2
    }
    if (event.keyCode == 13) {
      event.currentTarget.click()
      if (callback) {
        callback()
      }
    }
  }

  function setupChatViewButtons() {
    var sendButton = document.querySelector('.livechat-textarea-send')
    if (sendButton && sendButton.getAttribute('role') != 'button') {
      sendButton.setAttribute('role', 'button')
      sendButton.setAttribute('tabindex', 0)
      sendButton.setAttribute('aria-label', 'Lähetä viesti')
      sendButton.addEventListener('keypress', clickElementOnEnter)
    }
  }

  function setupChatTopicButtons(className) {
    var elements = document.querySelectorAll(className)
    for (var element of elements) {
      if (element.getAttribute('role') == 'button') {
        continue
      }
      element.setAttribute('role', 'button')
      element.setAttribute('tabindex', 0)
      element.addEventListener(
        'keypress',
        clickElementOnEnter.bind(null, setupChatViewButtons),
      )
    }
  }

  // hook into pushToDiscussion to listen when new buttons are added to chat
  function setupChatListener() {
    var originalPushToDiscussion = sf_sdk.pushToDiscussion
    sf_sdk.pushToDiscussion = function (html) {
      originalPushToDiscussion(html)
      setTimeout(function () {
        setupChatTopicButtons('.sf-conversation-cta')
      }, 0)
    }
  }

  // add tabindex for 'open chat' button
  function setupChatOpenButton() {
    var element = document.querySelector('.sf-prem-bubble')
    element.setAttribute('role', 'button')
    element.setAttribute('tabindex', 0)
    element.setAttribute('aria-label', 'Avaa chat')
    element.setAttribute('aria-controls', 'sf-prem-chat')
    element.addEventListener(
      'keypress',
      clickElementOnEnter.bind(null, function () {
        setupChatViewButtons()

        var chat = document.getElementById('sf-prem-chat')
        if (chat && chat.classList.contains('sf-open')) {
          element.setAttribute('aria-expanded', true)
        } else {
          element.setAttribute('aria-expanded', false)
        }
      }),
    )
  }

  // set id and tabindex for chat close button
  function setupChatCloseButton() {
    // one close button inside #sf-prem-chat, one outside
    var closeElements = document.querySelectorAll('.sf-header-close')
    for (var closeElement of closeElements) {
      closeElement.setAttribute('id', 'close-chat')
      closeElement.setAttribute('tabindex', 0)
      closeElement.setAttribute('role', 'button')
      closeElement.setAttribute('aria-label', 'Sulje chat')
      closeElement.addEventListener('keypress', clickElementOnEnter)
    }
  }

  // toggle topics "outside" of chat with keyboard
  var serviceformTopicsLoaded = setInterval(function () {
    var elements = document.querySelector('.sf-conversation-cta')
    if (!elements) {
      return
    }
    clearInterval(serviceformTopicsLoaded)
    setupChatTopicButtons('.sf-conversation-cta')
  }, 1000)

  // open chat from chat bubble with keyboard
  var closeButtonRetryCount = 0
  var serviceformLoaded = setInterval(function () {
    var element = document.querySelector('.sf-prem-bubble'),
      closeElements = document.querySelectorAll('.sf-header-close')
    if (!element) {
      return
    }

    // chat open? one close button in DOM -> continue
    // chat closed? two close buttons, one of which will appear a bit later -
    // or not. It might not appear and we need to continue either way
    if (
      !element.classList.contains('sf-open') &&
      closeElements.length < 2 &&
      closeButtonRetryCount < 3
    ) {
      closeButtonRetryCount += 1
      return
    }
    clearInterval(serviceformLoaded)
    setupChatOpenButton()
    setupChatCloseButton()
    setupChatListener()
  }, 1000)
})()
